/**
 * Extracts the filename without its extension
 * @param fileName - The full filename including extension
 * @returns The filename without extension
 * @example
 * getFileNameWithOutExt("document.pdf") // returns "document"
 * getFileNameWithOutExt("my.file.txt") // returns "my.file"
 * getFileNameWithOutExt("noextension") // returns "noextension"
 * getFileNameWithOutExt("") // returns ""
 */
export const getFileNameWithOutExt = (fileName: string): string => {
    if (!fileName) return '';
    
    // Handle filenames with multiple dots
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) return fileName;
    
    return fileName.substring(0, lastDotIndex);
}

export const isSelected = (locationPath: string, menuPath: string) => {
  const decodedLocation = decodeURIComponent(locationPath);
  const decodedMenuPath = decodeURIComponent(menuPath);
  const result = decodedLocation === decodedMenuPath;
  // Optional: console.log(`[isSelected] locationPath="${locationPath}" (decoded: "${decodedLocation}"), menuPath="${menuPath}" (decoded: "${decodedMenuPath}"), result=${result}`);
  return result;
};